import {Fragment, useState} from "react";
import {useHistory} from "react-router-dom";
import saveAs from "file-saver";
import SmallSpinner from "../SmallSpinner";

function UnpaidInvoiceRow({invoice, selectedInvoice, setError}) {
	const history = useHistory();
	const [loading, setLoading] = useState(false);

	async function downloadInvoice() {
		if (!selectedInvoice) {
			return;
		}
		setLoading(true);
		setError('');
		try {
			const response = await fetch(process.env.REACT_APP_endPoint + '/v1/invoices/' + selectedInvoice + '/xero-pdf', {
				method: "GET",
				credentials: "include"
			});
			if (response.status === 200) {
				const blob = await response.blob();
				let filename = 'invoice-' + selectedInvoice + '-unpaid' + '.pdf';
				saveAs(blob, filename);
			}
			else {
				setError('Failed to download Xero invoice PDF.');
			}
		}
		catch (e) {
			console.error(e);
			setError('Failed to download Xero invoice PDF.');
		}
		finally {
			setLoading(false);
		}
	}

	const today = new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"
	const overdue = invoice.dueDate && invoice.dueDate < today;

	const rowClass = selectedInvoice === invoice.id
		? "table-secondary"
		: overdue ? "table-warning" : "";

	return (
		<tr onClick={(evt) => {
			history.push({
				pathname: "/payments/unpaidInvoices",
				search: "?invoiceId=" + invoice.id
			});
		}} className={rowClass}>
			<td>{invoice.messageCount > 0 && <i className="bi bi-star-fill text-warning" />} {invoice.fullName}</td>
			<td>{invoice.email} {invoice.isLsp && <Fragment>({invoice.companyName})</Fragment>}</td>
			<td>{invoice.invoiceDate ?? invoice.stamp}</td>
			<td>{invoice.dueDate}</td>
			<td>{invoice.stripePlatform}</td>
			<td>&euro;{invoice.value.toLocaleString()}</td>
			<td className="text-center">
				{invoice.xero_invoice_id ?
					<button className="btn btn-sm btn-outline-secondary" onClick={(evt) => {
						evt.stopPropagation();
						downloadInvoice();
					}} disabled={loading}>
						{loading ? <SmallSpinner /> : <i className="bi bi-download"></i>}
					</button>
				: "--"}
			</td>
		</tr>
	);
}

export default UnpaidInvoiceRow;